<template>
  <div class="
    sw-grid-flex
    sw-grid-flex--dir-column--tab
    sw-grid-flex--wrap--tab
    sw--padding-vert-4">
    <div class="sw--height-full sw-grid-flex sw-grid-flex--wrap sw-grid-flex--align-center">
      <div class="sw-grid-flex__cell-1-1">
        <div class="left gray-tab"
             v-for="(tab,index) in tabs"
             :key="index"
             @click="selectedTabIndex = index"
             :class="selectedTabIndex === index ? 'gray-tab--disabled' : ''">
          {{tab.title}}
        </div>
      </div>
      <div class="sw-grid-flex__cell-1-1 sw--padding-top-3">
        <keep-alive>
          <component
            :is="selectedTab.component"
            :material-id="materialId"
            :printer-technology-ids="printerTechnologyIds"
            :current-material="currentMaterial"
            v-bind="selectedTab.props"
            v-on:error="handleError"
            v-on:success="handleSuccess"/>
        </keep-alive>
      </div>
    </div>
  </div>
</template>

<script>

    import MaterialPrinter
        from "rrViewComponents/Inshape/Admin/Materials/AddMaterial/PrinterComponent/material-printer";
    import VueDataMapMixin from 'js/lib/vue/mixins/vue-data-map-mixin';
    import VueSwMixin from 'js/lib/vue/mixins/vue-sw-mixin';
    import MaterialBasicInfo
        from "rrViewComponents/Inshape/Admin/Materials/AddMaterial/BasicInfoComponent/material-basic-info";
    import MaterialManufacturers
        from "rrViewComponents/Inshape/Admin/Materials/AddMaterial/ManufacturerComponent/material-manufacturers";
    import MaterialPrintability
        from "rrViewComponents/Inshape/Admin/Materials/AddMaterial/PrintabilityComponent/material-printability";
    import MaterialPricing
        from "rrViewComponents/Inshape/Admin/Materials/AddMaterial/PricingComponent/material-pricing";
    import MaterialGuideline
        from "rrViewComponents/Inshape/Admin/Materials/AddMaterial/GuidelineComponent/material-guideline";
    import TariffCode
        from "rrViewComponents/Inshape/Admin/Materials/AddMaterial/TariffCodeComponent/tariff-code";

    import _ from 'underscore';


    export default {
        name: 'new-material-app',

        mixins: [VueDataMapMixin, VueSwMixin],

        components: {
            MaterialPrinter,
            MaterialGuideline,
            MaterialPrintability,
            MaterialManufacturers,
            MaterialPricing,
            MaterialBasicInfo,
            TariffCode
        },

        props: {
            userGroups: {type: Array, default: () => ([])},
            materialGroups: {type: Array, default: () => ([])},
            materialFamilies: {type: Array, default: () => ([])},
            manufacturers: {type: Array, default: () => ([])},
            materialShopperFamilies: {type: Array, default: () => ([])},
            designGuidelines: {type: Array, default: () => ([])},
            printabilityChecks: {type: Array, default: () => ([])},
            printers: {type: Array, default: () => ([])},
            resourceClasses: {type: Array, default: () => ([])},
            currentMaterial: {type: Object, required: false, default: () => ({})},
            tariffCodes: {type: Array, default: () => ([])},
        },
        created() {
            if (this.currentMaterial && !_.isEmpty(this.currentMaterial)) {
                this.materialId = parseInt(this.currentMaterial.basicInfo.id);
                this.printerTechnologyIds = this.currentMaterial.printerTechnologies.map(a => a.printer_technology_material_id);
            }
        },
        data: function () {
            return {
                selectedTabIndex: 0,
                materialId: null,
                printerTechnologyIds: [],
                tabs: [
                    {
                        title: 'Basic Information',
                        component: 'material-basic-info',
                        props: {
                            userGroups: this.userGroups,
                            materialGroups: this.materialGroups,
                            materialFamilies: this.materialFamilies,
                            materialShopperFamilies: this.materialShopperFamilies,
                        }
                    },
                    {
                        title: 'Pricing',
                        component: 'material-pricing',
                        props: {}
                    },
                    {
                        title: 'Design Guidelines',
                        component: 'material-guideline',
                        props: {guidelines: this.designGuidelines}
                    },
                    {
                        title: 'Printers',
                        component: 'material-printer',
                        props: {
                            printers: this.printers,
                            resourceClasses: this.resourceClasses
                        }
                    },
                    {
                        title: 'Printability Checks',
                        component: 'material-printability',
                        props: {printabilityChecks: this.printabilityChecks}
                    },
                    {
                        title: 'Manufacturers',
                        component: 'material-manufacturers',
                        props: {manufacturers: this.manufacturers}
                    },
                    {
                        title: 'Tariff Codes',
                        component: 'tariff-code',
                        props: {tariffCodes: !_.isEmpty(this.currentMaterial) ? this.currentMaterial.tariffCodes : []}
                    }
                ]
            }
        },
        computed: {
            selectedTab() {
                return this.tabs[this.selectedTabIndex];
            }
        },
        methods: {
            handleSuccess(data) {
                if (this.selectedTab.component === 'material-basic-info') {
                    window.location.href = '/admin/material/edit?materialId=' + data.materialId;
                    this.materialId = parseInt(data.materialId);
                }
                if (this.selectedTab.component === 'material-printer') {
                    this.printerTechnologyIds = data.printerTechnologyIds;
                }
            },
            handleError(data) {
                const response = JSON.parse(data.responseText);
                this.$sw.notifications.error(response.error)
            }
        }
    }
</script>
